module.exports = __webpack_public_path__ + "img/mobile/PromoBetBar/exit@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/PromoBetBar/exit@1x.png
// module id = 196
// module chunks = 0